<template>
    <div
        :class="`pointer-events-auto w-full max-w-sm rounded-lg shadow-2xl ${rootThemeClass}`"
        data-spec-class="base-toast"
        :data-spec-value="toast.type"
    >
        <div class="overflow-hidden rounded-lg shadow-xs">
            <div class="p-4">
                <div class="flex items-start">
                    <div
                        class="shrink-0"
                        data-spec-class="base-toast__icon"
                        :data-spec-value="toast.type"
                    >
                        <component
                            :is="iconComponent"
                            :class="`h-6 w-6 ${iconThemeClass}`"
                        />
                    </div>
                    <div class="ml-3 w-0 flex-1 pt-0.5">
                        <p class="text-sm leading-5 font-medium text-primary">
                            {{ toast.title }}
                        </p>
                        <p
                            v-if="toast.text"
                            class="mt-1 text-sm leading-5 text-tertiary"
                        >
                            {{ toast.text }}
                        </p>
                    </div>
                    <div class="ml-4 flex shrink-0">
                        <BaseButtonClose @click="emit('close')" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {
    XCircleIcon,
    CheckCircleIcon,
    InformationCircleIcon,
    ExclamationTriangleIcon,
} from '@heroicons/vue/20/solid';
import { computed } from 'vue';
import { ToastType, type Toast } from '@/types';
import BaseButtonClose from './BaseButtonClose.vue';

const props = defineProps<{
    toast: Toast;
}>();

const emit = defineEmits<{
    close: [];
}>();

const iconComponent = computed(() => {
    switch (props.toast.type) {
        case ToastType.Success:
            return CheckCircleIcon;
        case ToastType.Info:
            return InformationCircleIcon;
        case ToastType.Warning:
            return ExclamationTriangleIcon;
        case ToastType.Error:
            return XCircleIcon;
        default:
            return CheckCircleIcon;
    }
});

const iconThemeClass = computed(() => {
    switch (props.toast.type) {
        case ToastType.Success:
            return 'text-success';
        case ToastType.Info:
            return 'text-brand';
        case ToastType.Warning:
            return 'text-warning';
        case ToastType.Error:
            return 'text-danger';
        default:
            return 'text-tertiary';
    }
});

const rootThemeClass = computed(() => {
    switch (props.toast.type) {
        case ToastType.Success:
            return 'bg-surface--elevated border border-success';
        case ToastType.Info:
            return 'bg-surface--elevated border border-brand';
        case ToastType.Warning:
            return 'bg-surface--elevated border border-warning';
        case ToastType.Error:
            return 'bg-surface--elevated border border-danger';
        default:
            return 'bg-surface--elevated border border-tertiary';
    }
});
</script>
